import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {EditCompanyDataComponent} from './edit-company-data/edit-company-data.component';
import {CompanyDataDetailsComponent} from './company-data-details/company-data-details.component';
import {CompanyElectricityComponent} from './electricity/company-electricity.component';
import {CompanyGasComponent} from './gas/company-gas.component';
import {LegalRepresentativesComponent} from './legal-representatives/legal-representatives.component';
import {
  ElectricityConsumptionPlaceDetailsComponent
} from './electricity/details/consumption-place/electricity-consumption-place-details.component';
import {GasConsumptionPlaceDetailsComponent} from './gas/details/consumption-place/gas-consumption-place-details.component';
import {ContractIndexComponent} from '../../public/contract-index/contract-index.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'date-identificare',
        component: EditCompanyDataComponent,
        data: {
          title: "Persoana juridica",
          breadcrumb: "Date identificare"
        }
      },
      {
        path: 'lista-companii',
        component: CompanyDataDetailsComponent,
        data: {
          title: "Persoana juridica",
          breadcrumb: "Companiile mele"
        }
      },
      {
        path: 'energie-electrica',
        component: CompanyElectricityComponent,
        data: {
          title: "Persoana juridica",
          breadcrumb: "Energie electrica"
        }
      },
      {
        path: 'energie-electrica/loc-consum',
        component: ElectricityConsumptionPlaceDetailsComponent,
        data: {
          breadcrumb: "Loc consum"
        }
      },
      {
        path: 'energie-electrica/index',
        component: ContractIndexComponent,
        data: {
          breadcrumb: "Completare index"
        }
      },
      {
        path: 'gaze-naturale',
        component: CompanyGasComponent,
        data: {
          title: "Persoana juridica",
          breadcrumb: "Gaze naturale"
        }
      },
      {
        path: 'gaze-naturale/loc-consum',
        component: GasConsumptionPlaceDetailsComponent,
        data: {
          breadcrumb: "Loc consum"
        }
      },
      {
        path: 'gaze-naturale/index',
        component: ContractIndexComponent,
        data: {
          breadcrumb: "Completare index"
        }
      },
      {
        path: 'conturi',
        component: LegalRepresentativesComponent,
        data: {
          title: 'Persoana juridica',
          breadcrumb: 'Conturi'
        }
      },
      {
        path: 'detalii-energie-electrica',
        component: ElectricityConsumptionPlaceDetailsComponent,
        data: {
          title: "Persoana juridica",
          breadcrumb: "Detalii loc de consum energie electrica"
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CompanyRoutingModule {
}
